import { type FC } from 'react'
import './_userCard.scss'

import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import avatarPlaceholder from 'assets/images/user_placeholder.png'
import { Button } from 'components/Button/Button'
import { addToast } from 'components/Toast/Toast'
import { blockUser } from 'services/endpoints/report'

import AvatarHolder from '../AvatarHolder/AvatarHolder'

const UserCardBlocked: FC<{
    user: any
}> = ({ user }) => {
    const { t } = useTranslation()
    const queryClient = useQueryClient()

    const blockMutation = useMutation(async () => await blockUser(user.id), {
        onSuccess: () => {
            queryClient.invalidateQueries('getBlockedUsers')
        },
        onError: () => {
            addToast('error', 'Something went wrong')
        }
    })

    return (
        <div className='userCard userCard--blocked'>
            <div className='userCard__avatar'>
                <AvatarHolder img={user?.avatar?.url || avatarPlaceholder} size='60' />
            </div>
            <div className='userCard__info'>
                <p className='userCard__info__name'>{user.name}</p>
                <p className='userCard__info__username'>{`@${user.username}`}</p>
            </div>
            <Button
                text={t('unblock')}
                color='transparent'
                type='transparent--black1px'
                font='mont-14-normal'
                height='3'
                width='fit'
                padding='2'
                clickFn={() => blockMutation.mutate()}
            />
        </div>
    )
}

export default UserCardBlocked
